<template>
  <el-dialog
    title="揽收详情"
    :visible="visible"
    width="1000px"
    :close-on-click-modal="false"
    @close="close"
  >
    <div class="box" ref="box">
      <div class="content">
        <p><strong>揽收单号：</strong>{{ detailInfo.pickUpOrderNo || "--" }}</p>
        <p><strong>预估重量（kg）：</strong>{{ detailInfo.estimatedWeight || 0 }} kg</p>
        <p><strong>预估体积（m³）：</strong>{{ detailInfo.estimatedVolume || 0 }} m³</p>
        <p><strong>申报箱数：</strong>{{ detailInfo.estimatedBoxNumber || 0 }} 箱</p>
      </div>

      <div class="btnBox">
        <el-button type="text" @click="print"
          >打印（{{ detailInfo.printCount || 0 }}）</el-button
        >
      </div>

      <div class="list">
        <div class="title">
          <span>揽收列表</span>
          <el-button
            type="danger"
            size="mini"
            @click="cancelBigPackage"
            :loading="cancelLoading"
            :disabled="cancelLoading"
            >取消揽收</el-button
          >
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%"
          :header-cell-style="{ textAlign: 'center' }"
          row-key="id"
          height="250"
        >
          <el-table-column label="图片" width="100" align="center">
            <template slot-scope="scope">
              <div
                class="details"
                style="display: flex; justify-content: center"
                v-for="item in scope.row.imageList"
                :key="item"
              >
                <div
                  class="details_left"
                  style="display: flex; justify-content: center"
                >
                  <el-popover trigger="hover" placement="right">
                    <img :src="item" alt />
                    <div class="scope_img" slot="reference">
                      <img :src="item" alt />
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="orderId"
            label="订单ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="amazonOrderId"
            label="订单号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="conveyNumber"
            label="运单号"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="fulfillmentId"
            label="速卖通入库单号"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { ajaxPost, Baseurl } from "@/api/api/api";
export default {
  name: "bigPackageDetail",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentForm: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: true,
      detailInfo: {},
      tableData: [],
      cancelLoading: false,
    };
  },
  mounted() {
    if (this.currentForm.id) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      const API =
        Baseurl + "aliexpressSemiHostingCollection/selectCollectionDetails";

      const sendData = { id: this.currentForm.id };
      const loading = this.$loading({
        target: this.$refs.box,
        text: "努力加载中...",
        background: "rgba(218,218,238,0.2)",
      });
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.detailInfo = data || {};
            this.tableData = this.detailInfo?.orderChannelList || [];
            loading.close();
          } else {
            this.$message.error(res.data);
          }
        })
        .catch(() => {
          this.$message.error("操作失败");
        });
    },
    print() {
      if (this.detailInfo.url) {
        window.open(this.detailInfo.url, "_blank");
        this.updatePrimtNum();
      } else {
        const API =
          Baseurl + "aliexpressSemiHostingCollection/getCollectionPdf";
        const sendData = {
          sellerId: this.detailInfo.sellerId,
          pickUpOrderNo: this.detailInfo.pickUpOrderNo,
        };
        ajaxPost(API, sendData).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            window.open(data, "_blank");
            this.updatePrimtNum();
          } else {
            this.$message.error(data);
          }
        });
      }
    },
    //更新打印次数
    updatePrimtNum() {
      const API =
        Baseurl + "aliexpressSemiHostingCollection/updateCollectionPrintCount";
      const sendData = {
        id: this.currentForm.id,
      };
      ajaxPost(API, sendData).then((res) => {
        if (res.data.code === 200) {
          this.getDetail();
        }
      });
    },
    //取消大包
    cancelBigPackage() {
      this.$confirm("是否取消揽收?", "取消揽收", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cancelBigPackageFn();
        })
        .catch(() => {});
    },
    cancelBigPackageFn() {
      const API = Baseurl + "aliexpressSemiHostingCollection/cancelCollection";
      const { id, sellerId, pickUpOrderNo } = this.currentForm;
      const sendData = {
        id,
        sellerId,
        pickUpOrderNo,
      };
      this.cancelLoading = true;
      ajaxPost(API, sendData)
        .then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.$message.success("取消成功");
            this.$emit("updateList");
            this.close();
          } else {
            this.$message.error(`取消失败:${data}`);
          }
          this.cancelLoading = false;
        })
        .cathc(() => {
          this.cancelLoading = false;
        });
    },
    close() {
      this.$emit("cancelVisible");
    },
  },
};
</script>
<style lang="scss" scoped>
div.content {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  p {
    width: calc(50% - 12px);
    line-height: 32px;
  }
}
.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.prduct_img {
  width: 500px;
  height: 500px;
}

.cell {
  display: flex;
  justify-content: center;
  align-items: center;
  .scope_img {
    display: initial;
  }

  .scope_img img {
    width: 55px;
    height: 55px;
  }
}

.details {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.details_left {
  width: 30%;
  text-align: center;
}

.details_right {
  width: 70%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.btnBox {
  display: flex;
  justify-content: flex-end;
}

div.list {
  div.title {
    display: flex;
    gap: 24px;
    align-items: center;
    margin-bottom: 16px;

    > span {
      font-size: 16px;
    }
  }
}
</style>
